import { BigNumber } from "shared/cubiq-model-multi-asset";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

/* AUTOCOMPLETE MODELS */

// optional default generic since 2.2
export class BfxAutocompleteGenericModel<T = any> {
  // must
  public value: T;
  public label: string;

  public lastFavorite: boolean;

  public hasPrivatization: boolean = false;

  constructor(_value?: any, _label?: string, _hasPrivatization?: boolean) {
    this.value = _value != null ? _value : null;
    this.label = _label != null ? _label : null;
    this.lastFavorite = null;
    this.hasPrivatization = _hasPrivatization;
  }
}

export class BfxAutocompleteAccountModel {
  // must
  public value: string;
  public label: string;
  // model
  public id: string;
  public name: string;
  public booking: string;
  public contact: string;
  public lastFavorite: boolean;

  public hasPrivatization: boolean = false;

  // keep default true
  public hasFullVisibility: boolean = true;

  constructor(
    _value?: string,
    _label?: string,
    _id?: string,
    _name?: string,
    _booking?: string,
    _contact?: string,
    _hasPrivatization?: boolean,
    _hasFullVisibility?: boolean,
  ) {
    this.value = _value ? _value : null;
    this.label = _label ? _label : null;
    this.id = _id ? _id : null;
    this.name = _name ? _name : null;
    this.booking = _booking ? _booking : null;
    this.contact = _contact ? _contact : null;
    this.lastFavorite = null;
    this.hasPrivatization = _hasPrivatization;

    if (_hasFullVisibility === true || _hasFullVisibility === false)
      this.hasFullVisibility = _hasFullVisibility;
  }
}

export class BfxAutocompleteClientModel {
  // must
  public value: string;
  public label: string;
  // model
  public id: string;
  public name: string;
  public lastFavorite: boolean;

  public hasPrivatization: boolean = false;

  constructor(
    _value?: string,
    _label?: string,
    _id?: string,
    _name?: string,
    _hasPrivatization?: boolean,
  ) {
    this.value = _value ? _value : null;
    this.label = _label ? _label : null;
    this.id = _id ? _id : null;
    this.name = _name ? _name : null;
    this.lastFavorite = null;
    this.hasPrivatization = _hasPrivatization;
  }
}

export class BfxAutocompleteTabModel {
  // must
  public tab: string;
  public label: string;
  public active: boolean;
  public disabled: boolean;

  constructor(_tab?: string, _label?: string, _active?: boolean, _disabled?: boolean) {
    this.tab = _tab ? _tab : null;
    this.label = _label ? _label : null;
    this.active = _active ? _active : null;
    this.disabled = _disabled ? _disabled : null;
  }
}

export class ICFixedCcyModel {
  // must
  public ccy: string; // 1 = base, 0 = non-base, null = '-'
  public ccyPair: string;
  constructor(_ccy: string = null, _ccyPair: string = null) {
    this.ccy = _ccy ? _ccy : null;
    this.ccyPair = _ccyPair ? _ccyPair : null;
  }
}
/**
 * @deprecated
 */
export class BfxRequestPriceModel {
  // must
  public value: BigNumber; // 1 = base, 0 = non-base, null = '-'
  public textValue: string;
  constructor(_value: BigNumber = null, _textValue: string = null) {
    this.value = _value;
    this.textValue = _textValue;
  }
}

export class BfxOrderEntrySuspendModel {
  suspendFrom: BfxOrderEntryTimeControlModel;
  suspendTo: BfxOrderEntryTimeControlModel;
  activated: boolean; // state of the checkbox
  constructor() {}
}

export class BfxOrderEntryTimeControlModel {
  public timeValue: string;
  public timezoneValue: BfxAutocompleteGenericModel; // was string, use .value
  public timezoneModel: CubiqTS.TimeZoneImpl;

  constructor() {}
}

export class BfxOrderEntryCommentsModel {
  public value: string;
  public manualComment: string;
  public defaultComment: string;
  public clientTraderComment: string;

  constructor() {}
}
